var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pc-preview-container"},[_c('img',{staticClass:"pc-phone-img",attrs:{"alt":"phone-empty","src":require("@shared/assets/img/partner-detail/my-tech.png")}})])
}]

export { render, staticRenderFns }